const contributerTypes = {
    "Contributer_Lyricist": 'Lyricist',
    "Contributer_Composer": 'Composer',
    "Contributer_ComposerLyricist": 'Composer and lyricist',
    "Artist_MainArtist": 'Main artist',
    "Artist_FeaturedArtist": 'Featured artist',
    "Publisher_Publisher": 'Publisher',
};
export default contributerTypes;